import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input, Spin } from "antd";
import PropTypes from "prop-types";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";
import { ObjectNumbersToEnglish } from "scripts/helpers";

const Component = ({ data = {}, onUpdate }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting, visible } = state;
	const { id, question } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleClose = () => {
		navigate(-1);
	};

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));
				values.iconId = values.icon?.id;

				values = ObjectNumbersToEnglish(values);

				delete values.icon;

				const action =
					hash === `#${Modals.CREATE}`
						? API.faq.create(values)
						: API.faq.update(id, values);

				action
					.then(() => {
						onUpdate(null, true);
						handleClose();
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (id) {
					setState((prevState) => ({ ...prevState, visible: true }));

					form.setFieldsValue(data);
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	const footer = (
		<>
			<Button type="primary" onClick={handleSubmit} loading={submitting}>
				{Resources.confirm}
			</Button>
			<Button onClick={() => handleClose()} loading={submitting}>
				{Resources.cancel}
			</Button>
		</>
	);

	return (
		<Drawer
			className="sp-form-drawer"
			footer={footer}
			onClose={() => handleClose()}
			title={
				id
					? `${Resources.edit} ${Resources.question} "${question || "-"}"`
					: `${Resources.add} ${Resources.question}`
			}
			maskClosable={false}
			open={visible}
			width={768}
		>
			<Form layout="vertical" form={form}>
				<Form.Item
					name="question"
					label={Resources.question}
					rules={Rules.required}
				>
					<Input />
				</Form.Item>
				<Form.Item
					name="answer"
					label={Resources.answer}
					rules={Rules.required}
				>
					<Input.TextArea rows={10} />
				</Form.Item>
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
};

export default Component;
